
import * as angular from "angular";

import { IVehicle } from "@interfaces/IVehicle";
import { VehicleService } from "@services/vehicle.service";
import { UnitConversionService, UnitConversionType } from "@services/unitConversion.service";
import { TranslationService } from "../../../../services/translation.service";

export class EditOdometerController {
    newOdometer: number;
    unchangedOdometer: number;
    odometersAreEqual: boolean;

    static $inject = ["$scope", "$mdDialog", "selectedVehicle", "vehicleService", "unitConversionService", "translationService"];

    constructor(
        private $scope: angular.IScope,
        private $mdDialog: angular.material.IDialogService,
        private selectedVehicle: IVehicle,
        private vehicleService: VehicleService,
        private unitConversionService: UnitConversionService,
        private translationService: TranslationService
    ) {

        this.initialise();
    }

    hide(): void {
        this.$mdDialog.hide();
    }

    update(): void {
        const newOdometer = this.unitConversionService.convertMilesToMeters(this.newOdometer);

        this.vehicleService.updateOdometer(this.selectedVehicle.Id, newOdometer, this.unchangedOdometer)
            .then(() => {
                this.hide();
                var successDialog = this.$mdDialog
                    .alert()
                    .title(this.translationService.t("Common.Success"))
                    .textContent(this.translationService.t("EditOdometer.SuccessDialog"))
                    .ok(this.translationService.t("Common.OK"));
                this.$mdDialog.show(successDialog);
            },
            () => {
                var alertDialog = this.$mdDialog
                    .alert()
                    .title(this.translationService.t("Common.Error"))
                    .textContent(this.translationService.t("EditOdometer.FailureDialog"))
                    .ok(this.translationService.t("Common.OK"));
                this.$mdDialog.show(alertDialog);
            });
    }

    private initialise() {
        this.$scope.$watch(
            () => { return this.newOdometer },
            () => {
                this.odometersAreEqual = this.newOdometer === this.unchangedOdometer;
            });

        const odometerKm = Math.round(this.selectedVehicle.Plot.Odometer / 1000);
        this.newOdometer = this.unitConversionService.convertToUserUnit(odometerKm, UnitConversionType.Distance);
        this.unchangedOdometer = this.unitConversionService.convertToUserUnit(odometerKm, UnitConversionType.Distance);
    }
}
